import Timer from './Timer';
import Game from '../../../Game';
import { IGameState } from '../../../State/Game/IGameState';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import QuestHelper from '../../../Utility/QuestHelper';
import DateHelper from '../../../Utility/DateHelper';
import { questTimerDuration } from '../../../Constants/Quests';

export default class QuestTimer extends Timer {
    public readonly questIndex: number;

    constructor(questIndex: number) {
        super();

        this.questIndex = questIndex;
    }
    public complete() {
        PlayerActions.refreshQuestAfterCooldown(this.questIndex);
    }
    public isCompleted(state?: IGameState): boolean {
        const cooldownStartedAt = this.getDate(state);
        if (cooldownStartedAt === null) return false;
        return QuestHelper.isCooldownCompleted(cooldownStartedAt);
    }
    public getDate(state: IGameState = Game.store.getState()): Date | null {
        return (
            state.playerState.quests[this.questIndex]?.cooldownStartedAt || null
        );
    }
    public getFormattedCountdown(state: IGameState) {
        return DateHelper.timeTo(
            DateHelper.now,
            new Date(this.getDate(state).getTime() + questTimerDuration),
            'hh:mm:ss'
        );
    }
}
